import { Alert, Badge, Group, Paper, Stack, Text, Title } from "@mantine/core";
import type { LegacyReportReviewState } from "../../../types/legacyReportReview";

export default function LegacyReportComparison({
  comparison,
}: {
  comparison?: LegacyReportReviewState["latestComparison"];
}) {
  if (!comparison)
    return (
      <Alert color="blue" title="Comparison needed">
        Compare the saved reconstruction with the original to check wording,
        identity, signatures, history, and graphics.
      </Alert>
    );
  return (
    <Stack gap="sm">
      <Title order={3}>Comparison findings</Title>
      <Text size="sm" c="dimmed">
        Original pages reviewed:{" "}
        {comparison.result.reviewedSourcePages.join(", ")} · Candidate pages
        reviewed: {comparison.result.reviewedCandidatePages.join(", ")}
      </Text>
      {comparison.result.discrepancies.length === 0 ? (
        <Alert color="green">
          The comparison found no discrepancies. Complete your own source and
          graphic review before approval.
        </Alert>
      ) : (
        comparison.result.discrepancies.map((finding) => (
          <Paper key={finding.id} withBorder p="md">
            <Stack gap="xs">
              <Group>
                <Badge color={finding.severity === "minor" ? "yellow" : "red"}>
                  {finding.severity}
                </Badge>
                <Text fw={600}>{finding.kind}</Text>
              </Group>
              <Text size="sm">{finding.description}</Text>
              <Text size="sm" c="dimmed">
                Source page {finding.sourcePage ?? "not located"} · Candidate
                page {finding.candidatePage ?? "not located"}
              </Text>
              <Text size="sm">Suggested correction: {finding.suggestion}</Text>
            </Stack>
          </Paper>
        ))
      )}
    </Stack>
  );
}
